<ion-item-sliding>
  <ion-item>
    <div class="item-content">
      <!-- Title / Label -->
      <div class="transaction-title-container">
        <ion-icon name="ellipse"></ion-icon>
        <ion-label class="transaction-title">{{
          transactionCategory.transaction.label
        }}</ion-label>
      </div>
      <!-- Additionnal info -->
      <div class="transaction-info">
        <!-- Amount -->
        <span
          class="transaction-price"
          [ngClass]="
            transactionCategory.transaction.amount >= 0
              ? 'transaction-price-credit'
              : ''
          "
        >
          {{
            transactionCategory.transaction.amount
              | currency: transactionCategory.transaction.currency
          }}
        </span>
        <!-- Category -->
        <div
          class="transaction-category"
          [ngStyle]="{
            'background-color': transactionCategory.category.color,
            color: 'var(--ion-color-medium-contrast)'
          }"
        >
          <ion-label class="category-label">
            {{ transactionCategory.category.label }}
          </ion-label>
          <ion-icon [name]="transactionCategory.category.icon"></ion-icon>
        </div>
      </div>
    </div>
  </ion-item>

  <!-- Available actions -->
  <ion-item-options side="start">
    <ion-item-option
      color="primary"
      (click)="alterTransaction.emit(transactionCategory.transaction)"
      >Modifier</ion-item-option
    >
  </ion-item-options>

  <ion-item-options
    side="end"
    (click)="deleteTransaction.emit(transactionCategory.transaction)"
  >
    <ion-item-option color="danger">Supprimer</ion-item-option>
  </ion-item-options>
</ion-item-sliding>
